import { Component, OnInit } from '@angular/core';
import { init } from '@sentry/angular-ivy';
import * as Sentry from "@sentry/angular-ivy";
import * as ld from 'launchdarkly-js-client-sdk';
import { environment } from 'src/environments/environment';
import { LaunchdarklyService } from '@acesso-io/launchdarkly-client-ts/lib/launchdarkly';
import { features } from 'process';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private launchdarklyService: LaunchdarklyService) { }

  ngOnInit(): void {
    this.checkLaunchDarklyFlag("people-analysis-enable-sentry").then((flag) => {
      console.log('Flag:', flag);
      if (flag) {
        
        init({
          dsn: environment.sentry.dsn,
          integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
          ],
          tracesSampleRate: environment.sentry.tracesSampleRate,
          tracePropagationTargets: environment.sentry.traceOrigin,
          replaysSessionSampleRate: 0.1,
          replaysOnErrorSampleRate: 1.0,
          beforeSend(event: any, hit: Sentry.EventHint) {
            if (event.exception.values[0].value.includes(`can't access property "length", value is null`)) {
              console.log("Não enviado!")
              return null;
            }
            event.extra = {
              ...event.extra,
              state: sessionStorage.getItem('state'),
              featureFlag: localStorage.getItem('featureFlagEsocial'),
              id: localStorage.getItem('id'),
              email: localStorage.getItem('analyst_email'),

            };
            console.log('Event:', event);
            console.log('Hit:', hit);
            if (event.exception) {
              console.log('Event:', event);
            }
            return event; 
          }
        })
      }
    })
  }

  async checkLaunchDarklyFlag(flagKey: string = ''): Promise<boolean> {
    const ctx = {
      kind: 'user',
      key: localStorage.getItem('id'),
    } as ld.LDContext;
    return this.launchdarklyService?.evaluateBoolean({flagKey});
  }
}
